import { useEffect } from 'react'
import { showVersionUpdateToast } from 'src/components/ui/VersionUpdateToastShadcn'
import { initVersionCheck, stopVersionPolling } from 'src/utils/versionCheck'

/**
 * Custom hook to handle version checking and notifications
 */
export function useVersionCheck() {
	useEffect(() => {
		// Initialize version checking with toast notification callback
		initVersionCheck((newVersion: string) => {
			showVersionUpdateToast(newVersion)
		})

		// Cleanup polling when component unmounts
		return () => {
			stopVersionPolling()
		}
	}, [])
}
